$(window).scroll(function(){
  var sticky = $('.product-filters-wrap'),
      scroll = $(window).scrollTop();

  if (scroll >= 200){
    sticky.addClass('is-sticky');
  $('.product-filters-placeholder').addClass('is-active');
  }
  else{
    sticky.removeClass('is-sticky');
    $('.product-filters-placeholder').removeClass('is-active');
  }
});


//  $(document).ready(function() {
//     if($('.waio--success-message').text()!==undefined && $('.waio--success-message').text()!==''){
//       $('.ws-registration-form--form').hide();
// }
// }); 


   $(document).ready(function() {
     if($('.success-msg').text()!==undefined && $('.success-msg').text()!==''){
       $('.customer-form').hide();
 }
 }); 

 $(document).ready(function() {
$('.open-popup-link').magnificPopup({
  type: 'inline',
  midClick: true,
  mainClass: 'mfp-fade'
});
   });


$(window).load(function() {
  $(".swym-title swym").click(function(){
    alert("The paragraph was clicked.");
  });

});